// import React, { createContext, useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Layout from './components/Layout';
// import Dashboard from './pages/Dashboard';
// import NewBooking from './pages/NewBooking';
// import AllBookings from './pages/AllBookings';
// import UpcomingBookings from './pages/UpcomingBookings';
// import Login from './pages/Login';
// import './App.css';

// // API Configuration
// export const API_CONFIG = {
//   BASE_URL: 'http://localhost/newtemplate/api',
//   LOGIN_URL: 'http://localhost/newtemplate/api/login',
//   BOOKING_URL: 'http://localhost/newtemplate/api/book',
//   UPDATE_BOOKING_URL: 'http://localhost/newtemplate/api/update-booking',
//   CLIENTS_URL: 'http://localhost/newtemplate/api/clients',
//   UPCOMING_URL: 'http://localhost/newtemplate/api/upcoming',
//   STATS_URL: 'http://localhost/newtemplate/api/stats',
//   PAYMENT_URL: 'http://localhost/newtemplate/api/payment',
//   VIEW_BOOKING_URL: 'http://localhost/newtemplate/api/viewbooking',
//   USERS_LIST_URL: 'http://localhost/newtemplate/api/users-list'
//   // DELETE_BOOKING_URL: 'http://localhost/newtemplate/api/delete-booking',
// };
// // export const API_CONFIG = {
// //   BASE_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api',
// //   LOGIN_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/login',
// //   BOOKING_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/book',
// //   UPDATE_BOOKING_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/update-booking',
// //   CLIENTS_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/clients',
// //   UPCOMING_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/upcoming',
// //   STATS_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/stats',
// //   PAYMENT_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/payment',
// //   VIEW_BOOKING_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/api/viewbooking',
// //   USERS_LIST_URL: 'https://mediumseagreen-shrew-778602.hostingersite.com/backend/users-list'
// //   // DELETE_BOOKING_URL: 'http://localhost/newtemplate/api/delete-booking',
// // };
// // Hotels Data
// export const HOTELS = [
//   { id: 1, name: 'Shivpuri House' },
//   { id: 2, name: 'New Agrabhavan' },
// ];

// // Meal Plans
// export const MEAL_PLANS = {
//   EP: { label: 'EP (Room Only)', emoji: '🛏️' },
//   CP: { label: 'CP (Breakfast)', emoji: '🍳' },
//   MAP: { label: 'MAP (Breakfast + Dinner)', emoji: '🍽️' },
//   AP: { label: 'AP (All Meals)', emoji: '🍱' },
// };

// // Auth Context
// export const AuthContext = createContext();

// function App() {
//   const [loginUser, setLoginUser] = useState(localStorage.getItem('loginUser') || '');
//   const [userId, setUserId] = useState(localStorage.getItem('userId') || null);
//   const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('auth_token'));

//   const handleLogin = (userData) => {
//     console.log('User data received in handleLogin:', userData); // Debug log
    
//     // Store auth token
//     const token = userData.auth_key || 'dummy_token';
//     localStorage.setItem('auth_token', token);
    
//     // Store user info
//     localStorage.setItem('loginUser', userData.username || '');
//     localStorage.setItem('userId', userData.id || '');
    
//     // Update state
//     setLoginUser(userData.username || '');
//     setUserId(userData.id || null);
//     setIsAuthenticated(true);
    
//     console.log('Stored userId:', userData.id); // Debug log
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('auth_token');
//     localStorage.removeItem('loginUser');
//     localStorage.removeItem('userId');
//     setLoginUser('');
//     setUserId(null);
//     setIsAuthenticated(false);
//   };

//   // Check if user is already logged in on mount
//   useEffect(() => {
//     const token = localStorage.getItem('auth_token');
//     const storedUser = localStorage.getItem('loginUser');
//     const storedUserId = localStorage.getItem('userId');
    
//     if (token && storedUser) {
//       setLoginUser(storedUser);
//       setUserId(storedUserId || null);
//       setIsAuthenticated(true);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ 
//       loginUser, 
//       userId, 
//       handleLogin, 
//       handleLogout, 
//       isAuthenticated 
//     }}>
//       <Router>
//         <Routes>
//           <Route path="/login" element={<Login />} />
//           <Route path="/" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
//             <Route index element={<Dashboard />} />
//             <Route path="dashboard" element={<Dashboard />} />
//             <Route path="new-booking" element={<NewBooking />} />
//             <Route path="all-bookings" element={<AllBookings />} />
//             <Route path="upcoming" element={<UpcomingBookings />} />
//           </Route>
//         </Routes>
//       </Router>
//     </AuthContext.Provider>
//   );
// }

// export default App;

// src/App.js
import React, { createContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import NewBooking from './pages/NewBooking';
import AllBookings from './pages/AllBookings';
import UpcomingBookings from './pages/UpcomingBookings';
import Login from './pages/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// API Configuration
// export const API_CONFIG = {
//   BASE_URL: 'http://localhost/newtemplate/api',
//   LOGIN_URL: 'http://localhost/newtemplate/api/login',
//   BOOKING_URL: 'http://localhost/newtemplate/api/book',
//   UPDATE_BOOKING_URL: 'http://localhost/newtemplate/api/update-booking',
//   CLIENTS_URL: 'http://localhost/newtemplate/api/clients',
//   UPCOMING_URL: 'http://localhost/newtemplate/api/upcoming',
//   STATS_URL: 'http://localhost/newtemplate/api/stats',
//   PAYMENT_URL: 'http://localhost/newtemplate/api/payment',
//   VIEW_BOOKING_URL: 'http://localhost/newtemplate/api/viewbooking',
//   USERS_LIST_URL: 'http://localhost/newtemplate/api/users-list'
// };
 export const API_CONFIG = {
  BASE_URL: 'https://tripsofindia.in/backend/api',
  LOGIN_URL: 'https://tripsofindia.in/backend/api/login',
  BOOKING_URL: 'https://tripsofindia.in/backend/api/book',
  UPDATE_BOOKING_URL: 'https://tripsofindia.in/backend/api/update-booking',
  CLIENTS_URL: 'https://tripsofindia.in/backend/api/clients',
  UPCOMING_URL: 'https://tripsofindia.in/backend/api/upcoming',
  STATS_URL: 'https://tripsofindia.in/backend/api/stats',
  PAYMENT_URL: 'https://tripsofindia.in/backend/api/payment',
  VIEW_BOOKING_URL: 'https://tripsofindia.in/backend/api/viewbooking',
  USERS_LIST_URL: 'https://tripsofindia.in/backend/users-list'
  // DELETE_BOOKING_URL: 'http://localhost/newtemplate/api/delete-booking',
};
// Hotels Data
export const HOTELS = [
  { id: 1, name: 'Shivpuri House' },
  { id: 2, name: 'New Agrabhavan' },
];

// Meal Plans
export const MEAL_PLANS = {
  EP: { label: 'EP (Room Only)', emoji: '🛏️' },
  CP: { label: 'CP (Breakfast)', emoji: '🍳' },
  MAP: { label: 'MAP (Breakfast + Dinner)', emoji: '🍽️' },
  DO: { label: 'DO (Dinner Only)', emoji: '🍱' },
};

// Auth Context
export const AuthContext = createContext();

function App() {
  const [loginUser, setLoginUser] = useState(localStorage.getItem('loginUser') || '');
  const [userId, setUserId] = useState(localStorage.getItem('userId') || null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('auth_token'));

  const handleLogin = (userData) => {
    console.log('User data received in handleLogin:', userData);
    
    const token = userData.auth_key || 'dummy_token';
    localStorage.setItem('auth_token', token);
    localStorage.setItem('loginUser', userData.username || '');
    localStorage.setItem('userId', userData.id || '');
    
    setLoginUser(userData.username || '');
    setUserId(userData.id || null);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('loginUser');
    localStorage.removeItem('userId');
    setLoginUser('');
    setUserId(null);
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    const storedUser = localStorage.getItem('loginUser');
    const storedUserId = localStorage.getItem('userId');
    
    if (token && storedUser) {
      setLoginUser(storedUser);
      setUserId(storedUserId || null);
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ 
      loginUser, 
      userId, 
      handleLogin, 
      handleLogout, 
      isAuthenticated 
    }}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="new-booking" element={<NewBooking />} />
            <Route path="all-bookings" element={<AllBookings />} />
            <Route path="upcoming" element={<UpcomingBookings />} />
          </Route>
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;